interface PromptProps {
    text: string
}

function Prompt({ text }: PromptProps) {
    return (
        <div className="prompt-container">
            <p> {text} </p>
        </div>
    )
}

export default Prompt